export const CSS_MODULE_FLAG = 'primer_react_css_modules_ga'
